import React, { useEffect, useMemo, useState } from 'react';
import ApexCharts from 'react-apexcharts';

const ApexChart = ({ labelList, dataList, type, width, showlegend,legendposition }) => {

    const series = dataList;
    const [options, setOptions] = useState({
        chart: {
            type: type ? type : 'donut',
        },

        labels: labelList, //['Red', 'Blue', 'Yellow'],                                                                              
        // colors: dataList.map(value => value < 0 ? '#FF0000' : 'Red'),
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: "100%",
                        //height: "100%"
                    },
                    legend: {
                        floating: true,
                        //position: 'r',

                    },
                },
            },
        ],
        legend: {
            show: true,
            position:legendposition? legendposition: 'left', // You can change this to 'top', 'right', or 'left' if needed
            horizontalAlign: 'center', // Aligns the legend horizontally
            itemMargin: {
                horizontal: 10, // Adds margin between items horizontally
                vertical: 5 // Adds margin between items vertically
            },
            formatter: function (seriesName, opts) {
                // Shorten legend text if needed
                return seriesName.length > 15 ? seriesName.substring(0, 10) + '..' : seriesName;
            }
        },
        plotOptions: {
            pie: {
                // customScale: 0.8,
                donut: {
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            // color: "#000000",
                            offsetY: -10,
                            formatter: function (val) {
                                return val && val?.length > 20 ? val.substring(1, 20) : val
                            }

                        },
                        value: {
                            show: true,
                            fontSize: '16px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: undefined,
                            offsetY: 16,
                            formatter: function (val) {
                                return val
                            }
                        },
                        // total: {
                        //     show: true,
                        //     showAlways: false,
                        //     label: 'Total',
                        //     fontSize: '16px',
                        //     fontFamily: 'Helvetica, Arial, sans-serif',
                        //     fontWeight: 600,
                        //     color: '#373d3f',
                        //     formatter: function (w) {
                        //         let d=w.globals.seriesTotals.reduce((a, b) => {
                        //             return a + b
                        //         }, 0)
                        //         return d.toFixed(2)
                        //     }
                        // }
                    },
                }
            }
        },
        tooltip: {
            y: {
                formatter: (value) => {
                    return `Rs.${value}`;
                }
            }
        },

    })


    useEffect(() => {
        // Update options whenever labels change
        setOptions(prevOptions => ({
            ...prevOptions,
            labels: labelList,

        }));
    }, [labelList]);

    return (
         <div style={{ }}>
            {/* <div style={{ flex: 2 }}>  display: 'flex', flexDirection: 'row' */}
                <ApexCharts
                    options={options}
                    series={series}
                    type={type}
                    width={width ? width : "100%"}
                // height={"100%"}

                />
            {/* </div>
            <div style={{ flex: 1, overflowY: 'auto' }}>
                <div>
                    {dataList.map((series, index) => (
                        <div key={index}>{series}</div> // Custom legend display
                    ))}
                </div>
            </div> */}
         </div>
    );
};

export default ApexChart;
